module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hD7qbL/tc-custom/9783989731851.jpg?1708053172691",
      "alt": "This image is the cover for the book The Crime At Vanderlynden's, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Crime At Vanderlynden's, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Excerpt: \"High up in the pale Flemish sky aeroplanes were wheeling and darting like bright-coloured insects, catching from one moment to another the glint of sun on metallic body or translucent wing. To any pilot or observer who had opportunity or gift for mere speculation, the sight that lay spread out below might have appeared wonderful. From far away on the seaboard with its coming and going of ships, there led rail, road, and wire, and by these three came material, human material, and human thought, up to that point just behind the battle-line where in dumps, camps (dumps of men) and Head-quarters (dumps of brains) they eddied a little, before streaming forward again, more slowly and covertly, by night, or below ground, up to the battle itself. There they were lost in that gap in life—that barren lane where the Irresistible Force dashing against the Immovable Post ground such a fine powder, that of material, very little, of men, very few, and of thought, nothing came splashing back.\"")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      R. H. Mottram\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0